import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cp-webview-body',
  templateUrl: './webview-body.component.html',
  styleUrls: ['./webview-body.component.scss']
})
export class WebviewBodyComponent implements OnInit {

  constructor() { }

  ngOnInit() {}
}
